import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import queryString from 'query-string';

import { ActionsDropdownForItem } from 'components/base/ActionsDropdown';
import CouponRemoveOwnerModal from 'components/customerDetail/CouponRemoveOwnerModal';
import CouponSelectOwnerModal from 'components/customerDetail/CouponSelectOwnerModal';
import CustomerRewardListFilter from 'components/customerDetail/CustomerRewardListFilter';
import SelectStoreOrUseCouponModal from 'components/customerDetail/SelectStoreOrUseCouponModal';
import {
  COUPON_TYPES,
  CUSTOMER_DETAIL_COUPON_TYPE,
  CUSTOMER_DETAIL_TAB_NAME,
  DELETE_RELATED_SECTIONS,
} from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';
import BaseListContainer from 'containers/base/BaseListContainer';
import BaseTabListContainer from 'containers/base/BaseTabListContainer';

import { getHashKeyString } from 'utils';

function CustomerRewardList({
  listFields,
  dataList,
  pageInfo,
  totalPage,
  totalCount,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const hash = getHashKeyString(location.hash);
  const params = useParams();
  const customerId = params.id;

  const [showModal, setShowModal] = useState(false);
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [showOwnerRemoveModal, setShowOwnerRemoveModal] = useState(false);
  const [selectCoupon, setSelectCoupon] = useState(null);

  useEffect(() => {
    if (hash !== CUSTOMER_DETAIL_TAB_NAME.coupons) {
      return;
    }

    setSelectCoupon(null);

    const parsedSearch = queryString.parse(location.search);
    const type = parsedSearch['type'] || '';
    const couponType = parsedSearch['coupon_type'] || '';
    const searchKey = parsedSearch['search'] || '';
    const stringPage = parsedSearch['page'] || 1;
    const page = parseInt(stringPage);

    dispatch({
      type: 'singleCoupon/getCustomerDetailCouponList',
      payload: {
        ...parsedSearch,
        customerId: customerId,
        page,
        search: searchKey,
        type: type,
        couponType,
      },
    });
  }, [dispatch, location]);

  return (
    <>
      <BaseTabListContainer
        hideTab={false}
        maxTabWidth={670}
        tabs={[
          { key: CUSTOMER_DETAIL_COUPON_TYPE.all, name: 'All Type' },
          { key: CUSTOMER_DETAIL_COUPON_TYPE.available, name: 'Available' },
          { key: CUSTOMER_DETAIL_COUPON_TYPE.unavailable, name: 'Unavailable' },
          {
            key: CUSTOMER_DETAIL_COUPON_TYPE.used_or_expired,
            name: 'Used or expired',
          },
        ]}
        groupActions={[]}
        pageInfo={pageInfo}
        totalCount={totalCount}
        filter={{ hasFilter: true, component: CustomerRewardListFilter }}
        listContent={
          <BaseListContainer
            fields={listFields}
            dataList={dataList}
            totalPage={totalPage}
            model={'singleCoupon'}
            permissionGroup={PermissionCodes.coupon}
            deleteInfo={{
              data: [],
              title: 'coupon',
              relatedName: 'coupon transaction',
              onComfirm: {},
              relatedSections: DELETE_RELATED_SECTIONS.COUPON,
            }}
            useCustomCommonActions={true}
            customCommonActions={(item) => {
              const actions = [];
              actions.push({
                name:
                  item.couponType === COUPON_TYPES.TICKET
                    ? 'Use ticket'
                    : 'Use coupon',
                action: (item) => {
                  setSelectCoupon(item);
                  setShowModal(true);
                },
                disabled: !item.isActive || !item.isEffective,
                requires: `change_${PermissionCodes.coupon}`,
              });

              if (item.couldSelectStore) {
                actions.push({
                  name: 'Select store only',
                  action: (item) => {
                    setSelectCoupon(item);
                    setShowModal(true);
                  },
                  disabled: !item.isActive || !item.isEffective,
                  requires: `change_${PermissionCodes.coupon}`,
                });
              }

              actions.push({
                name:
                  item.couponType === COUPON_TYPES.TICKET
                    ? 'Update ticket owner'
                    : 'Update coupon owner',
                action: (item) => {
                  setSelectCoupon(item);
                  setShowOwnerModal(true);
                },
                disabled: item?.isUsed || item?.isExpired,
                requires: `change_${PermissionCodes.coupon}`,
              });

              actions.push({
                name:
                  item.couponType === COUPON_TYPES.TICKET
                    ? 'Remove ticket'
                    : 'Remove coupon',
                action: (item) => {
                  setSelectCoupon(item);
                  setShowOwnerRemoveModal(true);
                },
                disabled: item?.isUsed || item?.isExpired,
                requires: `change_${PermissionCodes.coupon}`,
              });

              return (
                <ActionsDropdownForItem
                  object={item}
                  actions={actions}
                  otherActions={[]}
                />
              );
            }}
            openNewTab
            customPathname="/coupons"
            customPathId="templateId"
          />
        }
      />
      <SelectStoreOrUseCouponModal
        customerId={customerId}
        coupon={selectCoupon}
        show={showModal}
        setShow={setShowModal}
      />
      <CouponSelectOwnerModal
        customerId={customerId}
        coupon={selectCoupon}
        show={showOwnerModal}
        setShow={setShowOwnerModal}
      />
      <CouponRemoveOwnerModal
        customerId={customerId}
        coupon={selectCoupon}
        show={showOwnerRemoveModal}
        setShow={setShowOwnerRemoveModal}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  listFields: state.singleCoupon.customerDetailCouponListDisplayFields,
  dataList: state.singleCoupon.customerDetailCouponList,
  pageInfo: state.singleCoupon.pageInfo,
  totalPage: state.singleCoupon.totalPage,
  totalCount: state.singleCoupon.totalCount,
});

export default connect(mapPropsToState)(CustomerRewardList);
